import { useState } from "react"

import { Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"

import ButtonComponent from "../../../../../Components/Button"
import Icon from "../../../../../Icon"
import Images from "../../../../../Images"
import {
  CreditsAutomationConnectGuide,
  guideRequiresConfirmation
} from "../../CreditsAutomationConnectGuide"

import styles from "./AutomateCreditsModal.module.less"

const { Title, Text } = Typography

const processorImage = (serviceName) =>
  Images[`integration_${serviceName}`] || Images.integration_missing

// A single connected processor: nothing to switch between, so no sidebar/steps - just the intro
// copy (or, for Stripe, an "already available" notice since `requires_request` is false) and a
// Submit button that (re)sends the account-level automation request (CHA1-2308). Submit stays
// disabled until the guide's confirmation checkbox is ticked, when that guide has one (CHA1-3389).
export const SingleProcessorView = ({ processor, onSubmit, requestFetching }) => {
  const { t } = useTranslation()
  const [confirmed, setConfirmed] = useState(false)
  const isAlreadyAvailable = !processor.requires_request
  const needsConfirmation = !isAlreadyAvailable && guideRequiresConfirmation(processor.service_name)
  const canSubmit = !needsConfirmation || confirmed

  return (
    <Flex vertical gap={16} className={styles.singleWrapper}>
      <div className={styles.singleIconCombo}>
        <img
          src={processorImage(processor.service_name)}
          width={20}
          height={20}
          alt={processor.display_name}
        />
        <div className={styles.icon}>
          <Icon type="automation_loop_blue" />
        </div>
      </div>

      <Title level={5} style={{ margin: 0 }}>
        {t("Automate credits")}
      </Title>

      {isAlreadyAvailable ? (
        <Text type="secondary">
          {t(
            "Your connected integration already gives Chargeback the transaction access required to handle system credit requests."
          )}
        </Text>
      ) : (
        <>
          <Text type="secondary">
            {t("Follow these steps to securely connect your _name_ account.", {
              name: processor.display_name
            })}
          </Text>
          <CreditsAutomationConnectGuide
            pp={processor.service_name}
            className={styles.guideWrapper}
            confirmed={confirmed}
            onConfirmedChange={setConfirmed}
          />
          {processor.failure_reason && (
            <Text className={styles.warningText}>
              {processor.failure_details || t(processor.failure_reason)}
            </Text>
          )}
        </>
      )}

      <Flex justify="end" className={styles.footer}>
        <ButtonComponent
          type="primary"
          loading={requestFetching}
          disabled={!canSubmit}
          onClick={onSubmit}
        >
          {t("Submit")}
        </ButtonComponent>
      </Flex>
    </Flex>
  )
}

export default SingleProcessorView
